import { useMemo } from 'react';

import type { GridInitialState } from '@mui/x-data-grid';

import { buildAscendingSorting } from '../../../../components/DataGrid/utils/build-ascending-sorting.util';
import { THIRD_PARTY_STATUS_ID } from '../../../../components/ThirdParties/columns/get-third-party-columns';

export const useInitialGridState = () => {
  const initialGridState = useMemo<GridInitialState>(
    () => ({
      sorting: buildAscendingSorting('lastName'),
      columns: {
        columnVisibilityModel: {
          [THIRD_PARTY_STATUS_ID]: false,
        },
      },
    }),
    [],
  );

  return { initialGridState };
};
